import type { LeagueDurationParams, LeagueInfo } from '@library/types/leagues';
import { getLeagueDurationAttributes } from '@bo-utils/leagues';
import { useMemo } from 'react';

export const useLeagueDurationAttributes = ({
  durationId,
  leagueInfo
}: LeagueDurationParams) => {
  const leagueDurationAttributes = useMemo(
    () =>
      getLeagueDurationAttributes({
        durationId,
        leagueInfo
      }),
    [durationId, leagueInfo]
  );
  return leagueDurationAttributes;
};

export const useLeagueDurationsAttributes = ({
  durationIds,
  leagueInfo
}: {
  durationIds: Array<string | undefined>;
  leagueInfo?: LeagueInfo;
}) => {
  const leaguesDurationsAttributes = useMemo(
    () =>
      durationIds.map((durationId) => {
        return getLeagueDurationAttributes({
          durationId,
          leagueInfo
        });
      }),
    [durationIds, leagueInfo]
  );
  return leaguesDurationsAttributes;
};
